import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import d2MenuSide from './components/menu-side';
import d2MenuHeader from './components/menu-header';
import d2Tabs from './components/tabs';
import d2HeaderFullscreen from './components/header-fullscreen';
import d2HeaderLocales from './components/header-locales';
import d2HeaderSearch from './components/header-search';
import d2HeaderSize from './components/header-size';
import d2HeaderTheme from './components/header-theme';
import d2HeaderUser from './components/header-user';
import d2HeaderLog from './components/header-log';
import d2HeaderColor from './components/header-color';
import { mapState, mapGetters, mapActions } from 'vuex';
import mixinSearch from './mixins/search';
import mainMenu from './components/mainMenu';
import orgSelect from './components/orgSelect';
import d2HeaderTools from './components/header-tools';
import headerDownloadList from './components/header-downloadList';
import headerEnvConfig from './components/header-envConfig';
import util from '@/libs/util';
export default {
  name: 'd2-layout-header-aside',
  mixins: [mixinSearch],
  components: {
    d2MenuSide: d2MenuSide,
    d2MenuHeader: d2MenuHeader,
    d2Tabs: d2Tabs,
    d2HeaderFullscreen: d2HeaderFullscreen,
    d2HeaderLocales: d2HeaderLocales,
    d2HeaderSearch: d2HeaderSearch,
    d2HeaderSize: d2HeaderSize,
    d2HeaderTheme: d2HeaderTheme,
    d2HeaderUser: d2HeaderUser,
    d2HeaderLog: d2HeaderLog,
    d2HeaderColor: d2HeaderColor,
    mainMenu: mainMenu,
    orgSelect: orgSelect,
    d2HeaderTools: d2HeaderTools,
    headerDownloadList: headerDownloadList,
    headerEnvConfig: headerEnvConfig
  },
  created: function created() {
    if (util.cookies.get('userInfo')) {
      this.userInfo = JSON.parse(util.cookies.get('userInfo'));
    }
  },
  data: function data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '250px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px',
      breadcrumb: [],
      userInfo: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('d2admin', {
    keepAlive: function keepAlive(state) {
      return state.page.keepAlive;
    },
    grayActive: function grayActive(state) {
      return state.gray.active;
    },
    transitionActive: function transitionActive(state) {
      return state.transition.active;
    },
    asideCollapse: function asideCollapse(state) {
      return state.menu.asideCollapse;
    },
    asideTransition: function asideTransition(state) {
      return state.menu.asideTransition;
    }
  })), mapGetters('d2admin', {
    themeActiveSetting: 'theme/activeSetting'
  })), {}, {
    /**
     * @description 用来实现带参路由的缓存
     */
    routerViewKey: function routerViewKey() {
      // 默认情况下 key 类似 __transition-n-/foo
      // 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
      var stamp = this.$route.meta["__stamp-".concat(this.$route.path)] || '';
      return "".concat(stamp ? "__stamp-".concat(stamp, "-") : '').concat(this.$route.path);
    },

    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup: function styleLayoutMainGroup() {
      return this.themeActiveSetting.backgroundImage ? {
        backgroundImage: "url('".concat(this.$baseUrl).concat(this.themeActiveSetting.backgroundImage, "')")
      } : {};
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/menu', ['asideCollapseToggle'])), mapActions('d2admin/account', ['logout'])), {}, {
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside: function handleToggleAside() {
      this.asideCollapseToggle();
    },
    // 点击展开按钮
    handleUnfoldBtn: function handleUnfoldBtn() {
      this.Bus.emit('onUnfoldBtn');
    },
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    }
  }),
  watch: {
    // 监听路由
    $route: {
      handler: function handler(val) {
        console.log('$route', val);
        this.breadcrumb[0] = val.meta.parent;
        this.breadcrumb[1] = val.meta.title ? val.meta.title : ''; // console.log('breadcrumb',this.breadcrumb);
        // 调用获取路由数组方法
        // this.getBreadList(val)
      },
      deep: true,
      immediate: true
    }
  }
};